(function () {
  'use strict';
  var config = JSON.parse(document.getElementById('l2c-membership-config').textContent);
  var variants = new Set(config.variants.map(String));
  var cart = config.cart;
  var queue = Promise.resolve();
  var root = function () { return (window.Shopify && Shopify.routes.root) || '/'; };
  var isMembership = function (item) { return variants.has(String(item.variant_id || item.id)); };
  var count = function () { return cart.items.filter(isMembership).reduce(function (n, item) { return n + item.quantity; }, 0); };
  var reason = function () { return config.isMember ? 'You already have a membership.' : count() ? 'Membership is already in your cart.' : ''; };
  var originals = new WeakMap();
  var observer;

  function syncUI() {
    if (observer) observer.disconnect();
    document.querySelectorAll('[data-pid], .js_add_to_cart_button, form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] input[type="submit"]').forEach(function (button) {
      var form = button.closest('form');
      var input = form && form.querySelector('[name="id"]');
      var id = button.dataset.pid || (input && input.value);
      if (!variants.has(String(id))) return;
      var message = reason();
      if (message) {
        if (!originals.has(button)) originals.set(button, { disabled: button.disabled && !button.matches('.is-loading, .ajax_loading, [data-membership-add]'), aria: button.getAttribute('aria-disabled'), title: button.getAttribute('title') });
        if ('disabled' in button) button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', message);
        button.setAttribute('data-membership-blocked', '');
      } else if (originals.has(button)) {
        var original = originals.get(button);
        if ('disabled' in button) button.disabled = original.disabled;
        ['aria-disabled', 'title'].forEach(function (attr) {
          var value = attr === 'title' ? original.title : original.aria;
          if (value === null) button.removeAttribute(attr); else button.setAttribute(attr, value);
        });
        button.removeAttribute('data-membership-blocked');
        originals.delete(button);
      }
    });
    document.querySelectorAll('[data-membership-offer]').forEach(function (offer) { offer.hidden = !!reason(); });
    document.querySelectorAll('.js_qty').forEach(function (input) {
      var id = input.dataset.productId || input.id.replace('updates_', '');
      if (!variants.has(String(id))) return;
      input.readOnly = true;
      input.dataset.max = '1';
      input.setAttribute('aria-label', 'Membership quantity, limited to one');
      var group = input.closest('.js-quantity');
      if (group) group.querySelectorAll('.js_plus, .js_minus').forEach(function (button) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-membership-quantity', '');
      });
    });
    if (observer) observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-pid', 'value'] });
  }

  async function readCart() {
    var response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
    cart = await response.json();
    syncUI();
  }

  function failure(message) {
    return new Response(JSON.stringify({ status: 422, description: message, membership_error: true }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    });
  }

  // All theme cart mutations share a queue, so rapid adds cannot race the cart check.
  window.l2cMembershipCartFetch = function (url, options) {
    var task = queue.then(async function () {
      await readCart();
      var body = options.body;
      var data = typeof body === 'string' ? JSON.parse(body) : Object.fromEntries(body.entries());
      var operation = new URL(url, location.origin).pathname;
      if (/\/add(?:\.js)?$/.test(operation)) {
        var items = data.items || [data];
        var additions = items.filter(isMembership);
        if (additions.length) {
          var quantity = additions.reduce(function (n, item) { return n + Number(item.quantity == null ? 1 : item.quantity); }, 0);
          if (config.isMember) return failure('You already have a membership.');
          if (count() + quantity > 1 || quantity !== 1) return failure('Only one membership can be added to your cart.');
        }
      } else if (/\/change(?:\.js)?$/.test(operation)) {
        var item = data.line ? cart.items[Number(data.line) - 1] : cart.items.find(function (line) {
          return String(line.key) === String(data.id) || String(line.variant_id) === String(data.id);
        });
        if (item && isMembership(item) && Number(data.quantity) > 0 && (config.isMember || count() - item.quantity + Number(data.quantity) > 1)) {
          return failure(config.isMember ? 'You already have a membership.' : 'Only one membership can be added to your cart.');
        }
      }
      var response = await fetch(url, options);
      // A failed refresh must not report a successful add as a failed purchase.
      if (response.ok) await readCart().catch(function () {});
      return response;
    }).catch(function (error) { return failure(error.message || 'Unable to update your cart. Please try again.'); });
    queue = task.then(function () {});
    return task;
  };

  async function addFromOffer(button) {
    var status = button.closest('[data-membership-offer]').querySelector('[data-membership-offer-status]');
    button.disabled = true;
    status.textContent = 'Adding membership…';
    var body = new FormData();
    body.set('id', button.dataset.pid);
    body.set('quantity', '1');
    body.set('sections', 'minicart');
    var response = await window.l2cMembershipCartFetch(root() + 'cart/add.js', { method: 'POST', body: body });
    var data = await response.json();
    button.disabled = false;
    if (!response.ok) status.textContent = data.description;
    else {
      status.textContent = '';
      document.body.dispatchEvent(new CustomEvent('ajax:addToCart', { detail: { form: body, response: data } }));
    }
    syncUI();
  }

  document.addEventListener('click', function (event) {
    var blocked = event.target.closest('[data-membership-blocked], [data-membership-quantity]');
    if (blocked) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    var button = event.target.closest('[data-membership-add]');
    if (button) { event.preventDefault(); addFromOffer(button); }
  }, true);
  document.addEventListener('submit', function (event) {
    var input = event.target.querySelector('[name="id"]');
    if (!input || !variants.has(String(input.value))) return;
    if (reason()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.alert(reason());
      return;
    }
    // The dedicated membership section handles its own loading and error messages.
    if (event.target.matches('.l2c-gold-purchase__form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var body = new FormData(event.target);
    body.set('sections', 'minicart');
    window.l2cMembershipCartFetch(root() + 'cart/add.js', { method: 'POST', body: body }).then(async function (response) {
      var data = await response.json();
      if (!response.ok) window.alert(data.description);
      else document.body.dispatchEvent(new CustomEvent('ajax:addToCart', { detail: { form: body, response: data } }));
    });
  }, true);
  function init() {
    observer = new MutationObserver(syncUI);
    syncUI();
    window.addEventListener('pageshow', function () { readCart().catch(function () {}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
